function toCents() {

  let toCentsDirective = {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attr, ngModel) {

      function toCents(euros) {
        return isNaN(euros) || Number(euros) < 0 ? undefined : Math.floor(euros);
      }

      function toEuro(cents) {
          return isNaN(cents) || Number(cents) < 0 ? undefined : cents * 100;
      }

      ngModel.$parsers.push(toEuro);
      ngModel.$formatters.push(toCents);
    }
  };

  return toCentsDirective;

}

export default toCents;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/officeDelivery/toCents.directive.js
 **/